import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import RightHandLinkButton from '@Components/Results/right-hand-link-button.component';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactTargetHelper from '@Components/Results/services/react-target-helper.service';
import uuid from 'uuid/v4';

function TargetRightHandLinks({ metadata, target, trackingAttrs, detailsExpanded }) {
  const openElementLink = useCallback(
    (type) => {
      if (typeof metadata !== 'undefined') {
        const requestParams = {
          hitSetKey: metadata.hitSetKey,
          resultName: metadata.resultName,
          searchId: metadata.searchId || uuid(),
        };

        if (metadata.order) {
          requestParams.order = metadata.order;
        }

        ReactTargetHelper.openElementLink(type, target, requestParams);
      }
    },
    [metadata, target]
  );

  const getTrackingAttrs = useCallback(
    () => ({
      ...trackingAttrs,
      'data-tracking': !detailsExpanded,
      'data-tracking-type': 'contentview,contentlinkclick',
      'data-tracking-action': 'target details',
    }),
    [trackingAttrs, detailsExpanded]
  );

  return (
    <div className="target-details-right els-btn-group-vertical">
      {target.substancesCount > 0 && (
        <RightHandLinkButton
          openElementLink={openElementLink}
          dataLinkType="substances"
          text={`Substances - ${target.substancesCount}`}
          type="link"
          iconPosition="right"
          size="sm"
          icon="chevron-right"
          {...getTrackingAttrs()}
        />
      )}
      {target.documentsCount > 0 && (
        <RightHandLinkButton
          openElementLink={openElementLink}
          dataLinkType="documents"
          text={`Documents - ${target.documentsCount}`}
          type="link"
          iconPosition="right"
          size="sm"
          icon="chevron-right"
          {...getTrackingAttrs()}
        />
      )}
    </div>
  );
}

TargetRightHandLinks.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
  trackingAttrs: PropTypes.object,
  detailsExpanded: PropTypes.bool,
};

export default TargetRightHandLinks;
